/**
 * WeddingCalendar — 읽기전용 미니 캘린더
 *
 * 예식일이 속한 월의 달력을 표시하고 예식일을 하이라이트한다.
 */

import { useMemo } from 'react'
import { getCalendarDays, isSameDay } from '../../ui/DatePicker.js'
import common from './common.module.css'

interface WeddingCalendarProps {
  date: Date
  className?: string
}

const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토']

export function WeddingCalendar({ date, className }: WeddingCalendarProps) {
  const year = date.getFullYear()
  const month = date.getMonth()
  const days = useMemo(() => getCalendarDays(year, month), [year, month])

  // 마지막 주가 모두 다음 달인 경우 제거
  const trimmedDays = useMemo(() => {
    const lastRowStart = days.length - 7
    const lastRowAllOther = days.slice(lastRowStart).every((d) => !d.currentMonth)
    return lastRowAllOther ? days.slice(0, lastRowStart) : days
  }, [days])

  return (
    <div className={`${common.calendar} ${className ?? ''}`}>
      <div className={common.calendarHeader}>
        {year}년 {month + 1}월
      </div>
      <div className={common.calendarWeekdays}>
        {WEEKDAYS.map((w, i) => (
          <span
            key={w}
            className={`${common.calendarWeekday} ${i === 0 ? common.calendarDaySun : i === 6 ? common.calendarDaySat : ''}`}
          >
            {w}
          </span>
        ))}
      </div>
      <div className={common.calendarGrid}>
        {trimmedDays.map(({ date: d, currentMonth }, i) => {
          const isHighlight = currentMonth && isSameDay(d, date)
          const dayOfWeek = d.getDay()
          const classes = [
            common.calendarDay,
            !currentMonth ? common.calendarDayOther : '',
            isHighlight ? common.calendarDayHighlight : '',
            dayOfWeek === 0 && !isHighlight ? common.calendarDaySun : '',
            dayOfWeek === 6 && !isHighlight ? common.calendarDaySat : '',
          ].filter(Boolean).join(' ')

          return (
            <span key={i} className={classes}>
              {d.getDate()}
            </span>
          )
        })}
      </div>
    </div>
  )
}
